import React from "react";
import {IonProgressBar, IonSkeletonText} from "@ionic/react";
import FieldView from "components/FieldView";
import EntityView from "components/EntityView";
import FormProprietario from "./FormProprietario/FormProprietario";
import {getFormDefProprietario} from "./FormProprietario/controller";
import fb from "lib/firebase";
import {actions} from "lib/app";
import {AppDispatch, RootState} from "global.state";
import {connect} from "react-redux";
import {pessoaTipoChoices, ProprietarioObject} from "models/Proprietario";
import {UserInfo} from "../../models/User";
import {AppState} from "../../models/app";

interface Props {
  instance: ProprietarioObject;
  goBack: () => void;
  loading: boolean;
  dispatch: AppDispatch;
  app: AppState;
}

interface State {
  allowDelete: {
    status: boolean;
    reason?: string;
  };
  allowEdit: {
    status: boolean;
    reason?: string;
  };
  criadoPor: {
    isLoading?: boolean;
    data: UserInfo | undefined;
    label?: string;
  }
}

class AbaProprietario extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);

    this.state = {
      allowDelete: {
        status: false,
      },
      allowEdit: {
        status: false,
      },
      criadoPor: {
        isLoading: true,
        data: undefined,
        label: undefined,
      }
    }
  }

  componentDidUpdate(prevProps: Readonly<Props>) {
    if (prevProps.instance.atualizado_em !== this.props.instance.atualizado_em) {
      this.setPermissoes();
    }
  }

  componentDidMount() {
    this.setPermissoes();
  }

  setPermissoes() {
    // load criado_por
    const {instance} = this.props;
    const {_orfao, criado_por, _users} = instance;

    const criado_por_id = criado_por.id;
    const sameUser = criado_por_id === this.props.app.user.uid;
    let allowDelete = false;
    let allowEdit = false;
    let allowDeteleReason: string | undefined;
    let allowEditReason: string | undefined;
    if (!sameUser) {
      allowDeteleReason = 'este proprietário foi criado por outro usuário.';
      allowEditReason = allowDeteleReason;
    } else {
      if (_orfao) {
        allowEdit = true;
        allowDelete = true;
      } else {
        allowDeteleReason = 'este proprietário está vinculado a fazendas.';
        allowEditReason = allowDeteleReason;
        if (_users.length === 1) {
          // nao esta em uso por outros usuarios, liberar editar
          allowEdit = true;
          allowEditReason = undefined;
        }
      }
    }

    if (sameUser) {
      this.setState({
        criadoPor: {
          isLoading: false,
          data: {
            id: criado_por_id,
          },
          label: 'Você',
        },
        allowDelete: {
          status: allowDelete,
          reason: allowDeteleReason,
        },
        allowEdit: {
          status: allowEdit,
          reason: allowEditReason,
        }
      });
    } else {
      // obter usuario
      fb.db.collection('users').doc(criado_por_id).get()
        .then((doc) => {
          const data = fb.doc(doc) as UserInfo;
          this.setState({
            criadoPor: {
              isLoading: false,
              data: {
                id: criado_por_id,
                nome: data.nome,
              },
              label: data.nome,
            },
            allowDelete: {
              status: allowDelete,
              reason: allowDeteleReason,
            },
            allowEdit: {
              status: allowEdit,
              reason: allowEditReason,
            }
          });
        });
    }
  }

  onDelete = () => {
    fb.db.collection('proprietarios').doc(this.props.instance.id).delete()
      .then(() => {
        this.props.dispatch(actions.notifySuccess('Proprietário excluído com sucesso.'));
        this.props.goBack();
      });
  };

  render() {
    const {instance} = this.props;
    const formDef = getFormDefProprietario();

    if (this.props.loading)
      return <IonProgressBar type="indeterminate"/>;

    return (
      <EntityView
        instance={this.props.instance}
        ModelForm={FormProprietario}
        entityLabel="Proprietário"
        gender="m"
        allowDelete={this.state.allowDelete.status}
        allowEdit={this.state.allowEdit.status}
        onDelete={this.onDelete}
        modalNoPadding={true}
      >
        <FieldView def={formDef.nome} value={instance.nome} className="text-2xl"/>
        <FieldView
          def={formDef.pessoa_tipo}
          value={instance.pessoa_tipo ? pessoaTipoChoices.getLabel(instance.pessoa_tipo) : ''}
        />
        <FieldView def={formDef.telefone} value={instance.telefone}/>

        <div className="flex flex-wrap">
          <div className="w-8/12">
            <FieldView def={formDef.cidade} value={instance.cidade}/>
          </div>
          <div className="w-4/12">
            <FieldView def={formDef.estado} value={instance.estado}/>
          </div>
        </div>

        <div className="app-modelview-section-title">
          Informações de acesso
        </div>

        <div className="md:flex md:flex-wrap">
          <div className="md:w-1/2">
            <FieldView
              label="Responsável"
              value={
                <>
                  {this.state.criadoPor.isLoading &&
                    <IonSkeletonText animated/>
                  }
                  {!this.state.criadoPor.isLoading && this.state.criadoPor.label &&
                    this.state.criadoPor.label
                  }
                </>
              }
            />
          </div>
          <div className="md:w-1/2">
            <FieldView
              label="Criado em"
              type="datetime"
              value={instance.criado_em}
            />
          </div>
        </div>

        <div className="md:flex md:flex-wrap">
          <div className="md:w-1/2">
            <FieldView
              label="Você pode editar?"
              type="string"
              value={`${this.state.allowEdit.status ? "Sim" : "Não"}${this.state.allowEdit.reason ? `, ${this.state.allowEdit.reason}` : ''}`}
            />
          </div>
          <div className="md:w-1/2">
            <FieldView
              label="Você pode excluir?"
              type="string"
              value={`${this.state.allowDelete.status ? "Sim" : "Não"}${this.state.allowDelete.reason ? `, ${this.state.allowDelete.reason}` : ''}`}
            />
          </div>
        </div>

      </EntityView>
    )
  }
}

export default connect(({app}: RootState) => ({app}))(AbaProprietario);
